import React, { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route,  Navigate } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import homeImage from "./assets/Home/glass-building.jpg";
import "./App.css";
import Teammisions from "./Components/About/Teammision";
import EnergySection from "./Components/Home/Oursolution";
import Whychoseus from "./Components/Home/Choseus";
import Cbgabout from "./Components/Products/SynergyCbg/about";
import CbgEnergyPage from "./Components/Products/SynergyCbg/Cbgenergy";
import CbgLocation from "./Components/Products/SynergyCbg/Cbglocation";
import CbgProjects from "./Components/Products/SynergyCbg/CbgProject";
import CbgQuoteForm from "./Components/Products/SynergyCbg/Cbgtouch";
import Companyabout from "./Components/Home/About";
import CompanyHome from "./Components/About/CompanyHome";
import CompanyAbout from "./Components/About/CompanyAbout";
import ScrollToTop from "./ScrollToTop";
import DrishtiVdo from "./Components/Services/itaumation/DrishtiVdo";

// Lazy Load Components
const Home = lazy(() => import("./Components/Home/Home"));
const VisionMision = lazy(() => import("./Components/About/VisionMision"));
const ITServices = lazy(() => import("./Components/About/Itservices"));
const CardGrid = lazy(() => import("./Components/About/Misisonservice"));
const Leadership = lazy(() => import("./Components/About/Leadership"));
const SynergyDrishti = lazy(() => import("./Components/Products/SynergyDrishti"));
const SynergyKawach = lazy(() => import("./Components/Products/SynergyKawach"));
const SynergyProm = lazy(() => import("./Components/Products/SynergyProm"));
const SynergyFom = lazy(() => import("./Components/Products/SynergyFom"));
const SynergyLfom = lazy(() => import("./Components/Products/SynergyLfom"));
const SynergyFabrication = lazy(() => import("./Components/Products/SynergyFabrication"));
const SynergyDefDispenser = lazy(() => import("./Components/Products/SynergyDefDispenser"));
const SynergyOrganicFertilizer = lazy(() => import("./Components/Products/SynergyOrganicFertilizer"));
const SynergyGreenDg = lazy(() => import("./Components/Products/SynergyCbg/SynergyDg"));
const TankerFabrication = lazy(() => import("./Components/Services/TankerFabrication"));
const ItAutomation = lazy(() => import("./Components/Services/itaumation/Itautomation"));
const About = lazy(() => import("./Components/Services/itaumation/About"));
const CardSection = lazy(() => import("./Components/Services/itaumation/Card"));
const ButtonTab = lazy(() => import("./Components/Services/itaumation/Tabcontent"));
const AchievementAndService = lazy(() => import("./Components/Services/itaumation/Achievement"));
const ProductVdo = lazy(() => import("./Components/Services/itaumation/ProductVdo"));
const Testimonial = lazy(() => import("./Components/Services/itaumation/Carsonal"));
const Faqs = lazy(() => import("./Components/Support/faqs"));
const ContactTemplate = lazy(() => import("./Components/Contact/Contactus"));
const CareerSection = lazy(() => import("./Components/Contact/Career"));
const RecruitmentProcess = lazy(() => import("./Components/Contact/RecruitmentProcess"));
const MissionValues = lazy(() => import("./Components/Contact/Missionvalue"));

const ScrollHandler = () => {
  useEffect(() => {
    const savedPosition = sessionStorage.getItem("scrollPosition");
    if (savedPosition) {
      window.scrollTo(0, parseInt(savedPosition, 10));
      sessionStorage.removeItem("scrollPosition");
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      sessionStorage.setItem("scrollPosition", window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return null;
};
// synergyWebApp
const App = () => {
  return (
    <BrowserRouter>
 

    
      <Header homeImage={homeImage} />
      <Suspense fallback={<div className="loading">Loading...</div>}>
        <ScrollHandler />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Home />
                <Companyabout />
                <EnergySection />
                <Whychoseus />
              </>
            }
          />
          <Route path="/home" element={<Navigate to="/" replace />} />
          <Route path="/company-profile" element={<><CompanyHome/> <ITServices /><CompanyAbout/></>} />
          {/* <Route
            path="/vision-mission"
            element={
              <>
                <VisionMision />
                <ITServices />
                <CardGrid />
                <Teammisions />
              </>
            }
          /> */}
          <Route path="/Leadership" element={<Leadership />} />
          <Route path="/Synergy-Drishti" element={<><SynergyDrishti /> <DrishtiVdo/></>} />
          <Route path="/Synergy-Kawach" element={<SynergyKawach />} />
          <Route path="/Synergy-fillnow" element={<TankerFabrication />} />
          <Route path="/Synergy-prom" element={<SynergyProm />} />
          <Route path="/Synergy-fom" element={<SynergyFom />} />
          <Route path="/Synergy-lfom" element={<SynergyLfom />} />
          <Route path="/Synergy-Fabrication" element={<SynergyFabrication />} />
          <Route path="/synergy-def-dispenser" element={<SynergyDefDispenser />} />
          <Route
            path="/Synergy-Dg"
            element={
              <>
                <SynergyGreenDg />
                <Cbgabout />
                <CbgEnergyPage />
                <CbgLocation />
                <CbgProjects />
                <CbgQuoteForm />
              </>
            }
          />
          <Route
            path="/synergy-organic-fertilizer"
            element={
              <>
                <SynergyOrganicFertilizer />
              </>
            }
          />
          <Route path="/tanker-fabrication-services" element={<TankerFabrication />} />
          <Route
            path="/it-automation"
            element={
              <>
                <ItAutomation />
                <About />
                <CardSection />
                <ButtonTab />
                <AchievementAndService />
                <ProductVdo />
                <Testimonial />
              </>
            }
          />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/Contact-Us" element={<ContactTemplate />} />
          <Route
            path="/Careers"
            element={
              <>
                <CareerSection />
                <RecruitmentProcess />
                <MissionValues />
              </>
            }
          />
        </Routes>
        <ScrollToTop />
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
